var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container sub_wrap",
    attrs: {
      "id": "container"
    }
  }, [_c('article', {
    staticClass: "content",
    attrs: {
      "id": "content"
    }
  }, [_c('Breadcrumb'), _vm.episode ? _c('div', {
    staticClass: "sub_section_wrap book_literary_detail"
  }, [_c('header', {
    staticClass: "literary_detail_head"
  }, [_c('h3', {
    staticClass: "literary_detail_heading"
  }, [_c('span', {
    staticClass: "literary_detail_state"
  }, [_vm._v("연재")]), _c('span', {
    staticClass: "literary_detail_subject"
  }, [_vm._v(_vm._s(_vm.episode.serialTitle))]), _c('span', {
    staticClass: "literary_detail_episode"
  }, [_vm._v(_vm._s(_vm.chapterText))])]), _c('h4', {
    staticClass: "literary_detail_title"
  }, [_vm._v(_vm._s(_vm.episode.title))])]), _c('section', {
    staticClass: "page_section",
    staticStyle: {
      "-webkit-user-select": "none",
      "-moz-user-select": "none",
      "-ms-user-select": "none",
      "user-select": "none"
    },
    attrs: {
      "oncopy": "return false",
      "oncut": "return false",
      "onpaste": "return false",
      "ondragstart": "return false"
    }
  }, [_c('div', {
    staticClass: "page_section_inner"
  }, [_c('LineBreakElement', {
    staticClass: "literary_detail_body",
    attrs: {
      "contents": _vm.episode.contents
    }
  }), _c('LiteraryDetailPaging', {
    attrs: {
      "is-previous-exist": _vm.isPreviousExist,
      "is-next-exist": _vm.isNextExist
    },
    on: {
      "nextClick": _vm.nextClickHandler,
      "previousClick": _vm.previousClickHandler,
      "shareClick": _vm.shareClickHandler,
      "toMenuClick": _vm.toMenuClickHandler
    }
  }), _c('LiteraryCommentPost', {
    ref: "literaryCommentPostRef",
    attrs: {
      "disabled": _vm.replyDisabled,
      "placeholder": _vm.replyPlaceholder
    },
    on: {
      "registerClick": _vm.registerClickHandler
    }
  })], 1)])]) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }